import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { AddBankAccountPage } from "@/modules/settings/pages/add-bank-account-page";
import { requireAuth } from "@/utils";

export const Route = createFileRoute("/settings/bank-information/add")({
  beforeLoad: requireAuth,
  component: () => (
    <>
      <DocumentTitle
        title="Add Bank Account"
        description="Add a new bank account for receiving payments."
      />
      <AddBankAccountPage />
    </>
  )
});
